import { catalogSummaryApi } from 'app/src/services/welfareportal'
import { ListItemRenderer, SeeMoreButton } from 'app/src/shared/components'
import { catalogVisibilityFunc, getFunnelDiscount } from 'app/src/shared/helpers'
import { useTranslation, useWebAppContext, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Card } from 'primereact/card'
import { useMemo } from 'react'
import Skeleton from 'react-loading-skeleton'

export function CatalogSummarySection() {
  const context = useWebAppContext()
  const funnelDiscount = getFunnelDiscount(context)
  const navigate = useWelfarePortalNavigate()
  const { t } = useTranslation('catalog')
  const catalogSummaryDetails = catalogSummaryApi.useCatalogSummaryList({
    pathParams: { templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })

  const activeCategories = catalogSummaryDetails?.data?.categories.filter((item: catalogSummaryApi.CatalogSummaryItem) =>
    catalogVisibilityFunc(item, context, true),
  )

  const evaluateShowDescription = () => {
    const shouldShowDescription = catalogSummaryDetails.data?.showDescription || !funnelDiscount.onlyDiscount

    if (shouldShowDescription) {
      return (
        <p className='col-span-11 col-start-1 my-[25px] text-[16px] font-normal leading-[24px] text-[#4A4A4A] md:col-span-11 md:col-start-1'>
          {catalogSummaryDetails.data?.description}
        </p>
      )
    }

    return <div className='my-6' />
  }

  const categoriesGridColumns = useMemo(() => {
    const length = activeCategories?.length || 0
    return length > 3 ? 'col-span-3' : 'col-span-4'
  }, [activeCategories])

  return (
    <div className='mx-auto' data-testid='CatalogSummarySection'>
      <div className='grid grid-cols-12'>
        <h3 className='col-span-11 col-start-1 text-[#4A4A4A] md:col-span-11 md:col-start-1' aria-label='Fruition mode'>
          {catalogSummaryDetails.data?.title}
        </h3>
        {evaluateShowDescription()}
      </div>

      {catalogSummaryDetails.isLoading ? (
        <Skeleton height={352} baseColor='#e5e7eb' highlightColor='#f3f4f6' data-testid='loading-element' />
      ) : (
        <ListItemRenderer
          data={{
            items: activeCategories,
          }}
          pt={{
            container: {
              className: 'grid grid-cols-12 mx-auto gap-4',
            },
            item: {
              className: `col-span-12 grid min-h-[352px] flex-1 flex-col md:col-span-6 lg:${categoriesGridColumns}`,
            },
            autofocus: {
              disabled: true,
            },
          }}
          renderItem={(category) => (
            <Card
              key={category.id}
              title={category.title}
              pt={{
                title: {
                  className: 'line-clamp-1',
                },
                footer: {
                  className: 'p-0',
                },
              }}
              footer={
                <SeeMoreButton
                  label={t('Catalog.CatalogCategories.ButtonLabel')}
                  action={() => {
                    navigate.goToShowcase({ macroCategoryId: category.id })
                  }}
                ></SeeMoreButton>
              }
            >
              <p className='m-0 line-clamp-6 min-h-[190px]'>{category.description}</p>
            </Card>
          )}
        />
      )}
    </div>
  )
}
